import React, {useEffect, useState} from 'react';
import './styles/councilbank.css';
import {OnConstruction, VideoLoader, VideoPlayer } from '../components/UXHelper';
import { ExtinctionVideoData, ExtinctionData, ApisProvider } from '../components/feactures/dataProvider';
import { iteratorTransacHistory } from '../components/feactures/dataIterator';
import { LayoutContainer } from './layouts/layout_bi_columns';
import { motion, AnimatePresence } from 'framer-motion';
import {ModalNotify} from '../components/Modals'

export const TaxesDesk = ({pricesFees}) => {

    const [rotateTaxes, setRotateTaxes] = useState(false);

    useEffect(() => {
        let switcher = null;

        switcher = setInterval(rotateTaxesDisplay, 5000);

        return () => {
            clearInterval(switcher);
        }
    
    }, [rotateTaxes]);
    

    const rotateTaxesDisplay = () => {
        if(rotateTaxes === true){
            setRotateTaxes(false);
        }
        else{
            setRotateTaxes(true);
        }
    }

    const switchTaxes = {
        initial: {opacity: 0},
        center: {
            opacity: 1,
            transition: {
                duration: 0.2,
                delay: 0.7,                    
            }
        },
        exit: {
            opacity: 0,
        }

    }
    
    return (
        <>
            <AnimatePresence initial={false}>
                {rotateTaxes
                    ?   <motion.div
                            initial='initial'
                            animate='center'
                            exit='exit'
                            variants={switchTaxes}
                            key={2}
                            className='taxes_desk_councilbank'
                        >
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.craftsuitfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Craft Suit Tax</span>
                            </div>
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.craftwepfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Craft Weapon Tax</span>
                            </div>
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.scrapfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Scrapyard Tax</span>
                            </div>
                        </motion.div>
                    :   <motion.div
                            initial='initial'
                            animate='center'
                            exit='exit'
                            variants={switchTaxes}
                            key={1}
                            className='taxes_desk_councilbank'
                        >
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.deployfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Deploy Team Tax</span>
                            </div>
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.repairfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Repair Item Tax</span>
                            </div>
                            <div className='tax_structurer_box_councilbank'>
                                <span className='tax_amount_structurer_councilbank'>{pricesFees.slotfee.split(".0000 ONYX")}<span className='symbol_amount_structurer_councilbank'>onyx</span></span>
                                <span className='tax_name_structurer_councilbank'>Slot Buy Tax</span>
                            </div>
                        </motion.div>
                }
            </AnimatePresence>
        </>
    )
}

export const TransferModule = ({userData, refreshData, onRefreshBalances, setNotify}) => {

    const [transferData, setTransferData] = useState({
        receiver: '',
        symbol: 'ONYX',
        amount: '',
        memo: '',
    })

    const handlerCapture = (e) => {
        const result = e.target.value;
        const id = e.target.id;
    
        if(Number(id) === 1){
          // RECEIVER
          setTransferData((state) => ({
            ...state,
            receiver: result,
          }));
        }
        else if(Number(id) === 2){
            // AMOUNT
            setTransferData((state) => ({
                ...state,
                amount: result,
            }));
        }
        else if(Number(id) === 3){
            // SYMBOL
            setTransferData((state) => ({
                ...state,
                symbol: result,
            }));
        }
        else if(Number(id) === 4){
            // MEMO
            setTransferData((state) => ({
                ...state,
                memo: result,
            }));
        }
    }

    const transfeTo = async() => {
        if(userData.whichProvider === 'Anchor'){
            try{
              const action = {
                account: ExtinctionData.ONYX_CONTRACT,
                name: 'transfer',
                authorization: [userData.auths],
                data: {
                  from: userData.username,
                  to: transferData.receiver,
                  quantity: `${transferData.amount}.0000 ${transferData.symbol}`,
                  memo: transferData.memo,
                },
              }
              userData.sessionData.transact({action}).then(({transaction}) => {
              //console.log(`Transaction broadcast! Id: ${transaction.id}`);
              onRefreshBalances();
              refreshData(transaction.id.toString());
              setTransferData({
                receiver: '',
                symbol: 'ONYX',
                amount: '',
                memo: '',
              })
              })
            }
            catch(err){
                
            }
        }
        else if(userData.whichProvider === 'WaxCloud'){
            try{
                const action = {
                    actions: [{
                        account: ExtinctionData.ONYX_CONTRACT,
                        name: 'transfer',
                        authorization: [{
                            actor: userData.username,
                            permission: 'active',
                          }],
                        data: {
                            from: userData.username,
                            to: transferData.receiver,
                            quantity: `${transferData.amount}.0000 ${transferData.symbol}`,
                            memo: transferData.memo,
                        },
                    }],
                }
                const transaction = await userData.sessionData.api.transact(action, {
                    blocksBehind: 3,
                    expireSeconds: 1200,
                  });
                  onRefreshBalances();
                  setTransferData({
                      receiver: '',
                      symbol: 'ONYX',
                      amount: '',
                      memo: '',
                    })
                    setNotify({
                        status: true,
                        error: false,
                        title: 'Success',
                        msg: 'Transaction Id:',
                        txId: transaction.transaction_id,
                      });
                    refreshData(transaction.transaction_id);
                    
              }
              catch(err){
                    const msgError = err.message.split('assertion failure with message: ').join('')
                    setNotify({
                        status: true,
                        error: true,
                        title: 'failed transaction',
                        msg: msgError,
                    });
              }
        }   
    }


    return(
        <>
        <div className='transfer_structer_box_councilbank'>
            <div className='title_transaction_history_councilbank'>
                <span>Transfer To</span>
            </div>
            <div className='action_transfer_box_councilbank'>
                <div className='receptor_transfer_container_councilbank'>
                    <p className='label_title_transfer_councilbak'>Receiver:</p>
                    <input id={1} type="text" placeholder='Username to receiver' value={transferData.receiver} onChange={handlerCapture}/>
                </div>
                <div className='amount_transfer_container_councilbank'>
                    <p className='label_title_transfer_councilbak'>Amount:</p>
                    <div className='tokens_container_transfer_councilbank'>
                        <input type="number" id={2} placeholder='0' value={transferData.amount} onChange={handlerCapture}/>
                        <select value={transferData.symbol} id={3} onChange={handlerCapture}>
                            <option value="ONYX" defaultValue={'ONYX'}>ONYX</option>
                            <option value="NEO">NEO</option>
                            <option value="CHAL">CHAL</option>
                        </select>
                    </div>
                </div>
                <div className='memo_transfer_container_councilbank'>
                    <p className='label_title_transfer_councilbak'>Memo: (Optional)</p>
                    <input id={4} type="text" placeholder='Description or Memo' value={transferData.memo} onChange={handlerCapture}/>
                </div>
                <div className='sendnow_transfer_container_councilbank'>
                    <button onClick={() => transfeTo()}>Transfer Now</button>
                </div>
            </div>
        </div>
        </>
    )
}

export const HistoryTransactions = ({username, refreshRecents}) => {

    const [transData, setTransData] = useState();
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            loadTransactionData(username)
        }, 1000);
    
      return () => {
        setLoadingData(true);
      }
    }, [refreshRecents])

    const loadTransactionData = async(account) => {       
        const api = `${ApisProvider.actionsApi}v2/history/get_actions?account=${account}&filter=waxonyxtoken%3Atransfer&skip=0&limit=10&sort=desc`;
  
        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const accountTransac = data.actions;
        if(Number(accountTransac.length) > 0){
            const result = iteratorTransacHistory(accountTransac, account);
            if(Number(result.length) > 0){
                setTransData({
                    status: true,
                    data: result,
                });
                setLoadingData(false);
            }
        }
        else{
            setTransData({
                status: false,
            });
            setLoadingData(false);
        }
    }

    if(loadingData){
        return (
            <div className='loading-box'>
                <div className="spinner-border">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if(transData.status === false){
        return (
            <div className='history_transactions_empty_structurer_councilbank'>
                <span>NO RECENT TRANSACTIONS</span>
            </div>
        )
    }

    return(
        <div className='history_transactions_structurer_councilbank'>
            {transData.data.map((x) => (
                <div className='transaction_box_councilbank' key={x.trx_id}>
                    <div className='date_info_box_transaction_councilbank'>
                        <span className='date_info_transaction_councilbank'>{x.date}</span>
                        <a href={`${ApisProvider.explorerProvider}${x.trx_id}`} target='_blank' className='link_explorer_info_transaction_councilbank'>View on Explorer</a>
                    </div>
                    <div className='transact_info_box_councilbank'>
                        <span className='transact_descrip_info_councilbank'>{x.amount.status === 'insert' ? `Transferred from ${x.from}` : `Transferred to ${x.to}`}</span>
                        <span className='transact_memo_info_councilbank'>{x.memo}</span>
                    </div>
                    <div className='amount_info_box_councilbank'>
                        <span className={`amount_info_councilbank ${x.amount.status}`}>{x.amount.data}</span>
                    </div>
                </div>

            ))}
        </div>
    )
}

export const CouncilBank = ({userData, showLoader, closerLoader, onRefreshBalances, pricesFees}) => {

    const [refreshRecents, setRefreshRecents] = useState();

    const [nofity, setNotify] = useState({
        status: false,
        error: false,
        title: '',
        msg: '',
        txId: '',
    })

    const refreshData = (tx_id) => {
        setRefreshRecents(tx_id)
    }
    
    if(!userData.isConnected){
        return (
            <div className='signIn_box'>
                <h2 className='signIn-letter'>You need to sign in before!</h2>
            </div>
        )
    }
    
    if(showLoader){
        return (
            <div className='loader_animation'>
            <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
          </div>
        )
    }

    return (
        <LayoutContainer styles_element={{padding: '0'}}>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
              {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                        setNotify({
                            status: false,
                            error: false,
                            title: '',
                            msg: '',
                            txId: '',
                        })
                      }}/>}
              </div>
            <div className='body_container_councilbak'>
                <div className='data_container_councilbank'>
                    <div className='header_data_container_councilbank'>
                        <motion.div className='creditcard_data_box_councilbank'
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            transition={{duration: 0.2, delay: 0.3}}
                        >
                            <div className='creditcard_structurer_councilbank'>
                                <div className='creditcard_upsection_structurer_councilbank'>
                                    <div className='titles_creditcard_structurer_councilbank'>
                                        <span className='bankname_creditcard_councilbank'>councilbank</span>
                                        <span className='title_creaditcard_councilbank'>World Bank</span>
                                    </div>
                                    <div className='logo_complement_creditcard_councilbank'>
                                        <span>CBC</span>
                                    </div>
                                </div>
                                <div className='creditcard_middlesection_structurer_councilbank'>
                                    <span className='digits_creditcard_councilbank'>3254</span>
                                    <span className='digits_creditcard_councilbank'>3464</span>
                                    <span className='digits_creditcard_councilbank'>8779</span>
                                    <span className='digits_creditcard_councilbank'>4563</span>
                                    <span className='digits_creditcard_councilbank'>9865</span>
                                </div>
                                <div className='creditcard_downsection_structurer_councilbank'>
                                    <span className='owner_name_creditcard_councilbank'>{userData.username}</span>
                                    <span>05/28</span>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                    <div className='body_data_container_councilbank'>
                        <motion.div className='history_transactions_box_councilbank'
                             initial={{opacity: 0, x: '-100px'}}
                             animate={{opacity: 1, x: '0'}}
                             transition={{duration: 0.2, delay: 0.4}}
                        >
                            <div className='title_transaction_history_councilbank'>
                                <span>Recent Transactions</span>
                            </div>
                            <div className='transaction_data_container_councilbank'>
                                <HistoryTransactions username={userData.username} refreshRecents={refreshRecents}/>
                            </div>
                        </motion.div>
                        <motion.div className='transfer_module_box_councilbank'
                            initial={{opacity: 0, y: '100px'}}
                            animate={{opacity: 1, y: '0'}}
                            transition={{duration: 0.2, delay: 0.5}}
                        >
                            <TransferModule userData={userData} refreshData={refreshData} onRefreshBalances={onRefreshBalances} setNotify={setNotify}/>
                        </motion.div>
                    </div>
                </div>
                <div className='infos_container_councilbank'>
                    <div className='greeter_box_councilbank'>
                        <div className='greeter_structurer_councilbank'>
                            <span className='title_greeter_councilbank'>Welcome, <span className='username_greeter_councilbank'>{userData.username}</span></span>
                        </div>
                    </div>
                    <div className='taxes_box_councilbank'>
                        <TaxesDesk pricesFees={pricesFees} />
                    </div>
                    <div className='current_balance_box_councilbank'>
                        <div className='current_balance_structer_councilbank'>
                            <span className='amount_current_balance_councilbank'>{userData.userBalances.bShortOnyx}<span className='symbol_current_balance_councilbank'>onyx</span></span>
                            <span className='title_current_balance_councilbank'>Current Balance</span>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutContainer>
    )
}
